// Launch week ended 2026-04-24, so isLaunchWeekActive() is permanently false and
// every strikethrough that reads it is dormant. The countdown banner that used to
// live here was deleted 2026-07-12 — exported, and imported by nobody.
export const LAUNCH_WEEK_END_ISO = '2026-04-24T23:59:59Z';

// DO NOT REVIVE THIS BY BUMPING THE DATE ABOVE.
//
// These are not prices Romulus ever charged. A struck-through $399 that was never
// the real price is a fictitious former price: 16 CFR 233.1(a) requires a former
// price to be "bona fide" — openly and actively offered, in good faith, for a
// reasonably substantial period. A perpetually-running "launch week" against an
// invented anchor is the fact pattern behind the Ascena and JC Penney
// reference-pricing class actions.
//
// This was live on the checkout page until 2026-07-12: every desktop buyer was told
// "Founder pricing · 63% off" against a $399 that had expired 79 days earlier — one
// click after the plan picker had honestly shown them $149.
//
// If you want comparison pricing, make the higher price real first: actually offer
// it for a substantial period, then discount from it.
export const LAUNCH_REGULAR_PRICES: Record<'starter' | 'cashflow' | 'scale' | 'agency', number> = {
  starter: 199,
  cashflow: 399,
  scale: 1299,
  agency: 2499,
};

export function isLaunchWeekActive(): boolean {
  return Date.now() < new Date(LAUNCH_WEEK_END_ISO).getTime();
}
